/* cp-gallery.js — main-product's cp_gallery_* settings (loaded by
   snippets/product-media-modal.liquid when cp_gallery_phone is on).
   1. Media modal, phones only: a tap on the enlarged image zooms it to 2.5× around
      the tapped point; a second tap fits it again. Pinch zoom still works.
   2. Caption list under the thumbnails (tablet and desktop): each item opens its
      image through Dawn's own thumbnail button, and the list follows the thumbnail
      that is current.
   3. Phones: only the slide in view keeps its "open media" button in the tab order,
      so the keyboard reaches previous / next without the off-screen slides.
   Styles: cp-product-detail.css (.cp-gallery-modal, .cp-gallery-list). */
(function () {
  var phone = window.matchMedia('(max-width: 749px)');

  document.addEventListener('click', function (event) {
    if (!phone.matches) return;
    var img = event.target.closest('.cp-gallery-modal .product-media-modal__content > img');
    if (!img) return;
    var content = img.parentElement;
    var rect = img.getBoundingClientRect();
    var x = (event.clientX - rect.left) / rect.width;
    var y = (event.clientY - rect.top) / rect.height;
    var zoomed = content.classList.toggle('cp-zoomed');
    if (!zoomed) {
      img.scrollIntoView({ block: 'center' });
      return;
    }
    // Keep the tapped point under the finger.
    content.scrollLeft = x * img.offsetWidth - (event.clientX - content.getBoundingClientRect().left);
    content.scrollTop = img.offsetTop + y * img.offsetHeight - (event.clientY - content.getBoundingClientRect().top);
  });

  // Each opening starts unzoomed.
  document.querySelectorAll('.cp-gallery-modal').forEach(function (modal) {
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        var content = modal.querySelector('.product-media-modal__content');
        if (content) content.classList.remove('cp-zoomed');
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });

  // Caption list: open the matching image, and mark the current one.
  document.querySelectorAll('.cp-gallery-list').forEach(function (list) {
    var gallery = list.closest('media-gallery');
    var thumbs = gallery ? gallery.querySelectorAll('.thumbnail-list__item .thumbnail') : [];
    var items = list.querySelectorAll('[data-cp-slide]');
    function sync() {
      items.forEach(function (item) {
        var thumb = thumbs[Number(item.dataset.cpSlide)];
        if (thumb && thumb.getAttribute('aria-current') === 'true') item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    }
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var thumb = thumbs[Number(item.dataset.cpSlide)];
        if (thumb) thumb.click();
      });
    });
    thumbs.forEach(function (thumb) {
      new MutationObserver(sync).observe(thumb, { attributes: true, attributeFilter: ['aria-current'] });
    });
    sync();
  });

  // Phones: the off-screen slides' "open media" buttons leave the tab order.
  document.querySelectorAll('media-gallery[data-cp-gallery]').forEach(function (gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var slides = viewer.querySelectorAll('.product__media-list > li');
    var current = slides[0];
    function apply() {
      slides.forEach(function (slide) {
        slide.querySelectorAll('.product__media-toggle').forEach(function (toggle) {
          if (phone.matches && slide !== current) toggle.setAttribute('tabindex', '-1');
          else toggle.removeAttribute('tabindex');
        });
      });
    }
    viewer.addEventListener('slideChanged', function (event) {
      if (event.detail && event.detail.currentElement) current = event.detail.currentElement;
      apply();
    });
    if (phone.addEventListener) phone.addEventListener('change', apply);
    apply();
  });
})();
